import { createFileRoute, Link } from "@tanstack/react-router";
import { z } from "zod";

import icon from "@/assets/images/icon.png";
import { NewPasswordForm } from "@/features/auth/modules/new-password/new-password-form";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(public)/new-password/")({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: m.auth_new_password_crumb(),
    };
  },
  validateSearch: z.object({
    token: z.string().optional(),
  }),
});

function RouteComponent() {
  const { token } = Route.useSearch();

  return (
    <div className="relative flex min-h-svh items-center justify-center overflow-hidden bg-background px-6 py-10">
      <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -left-1/4 -top-1/3 size-[45rem] rounded-full bg-[radial-gradient(circle_at_center,var(--primary),transparent_60%)] opacity-30 blur-[140px]" />
        <div className="absolute -right-1/4 -bottom-1/4 size-[38rem] rounded-full bg-[radial-gradient(circle_at_center,var(--secondary),transparent_60%)] opacity-25 blur-[140px]" />
      </div>
      <div className="relative z-10 flex w-full max-w-xl flex-col items-center gap-8">
        <Link
          to="/"
          className="relative flex items-center justify-center w-16 h-16 border border-transparent rounded-2xl shadow-2xl [background:linear-gradient(var(--background),var(--background))_padding-box,conic-gradient(var(--primary),var(--secondary)_25%,var(--secondary)_75%,var(--primary)_100%)_border-box] before:absolute before:inset-0 before:bg-primary/10 before:rounded-2xl"
        >
          <div aria-hidden className="bg-primary/30 absolute inset-0 blur-2xl" />
          <img src={icon} alt="" className="relative size-8 rounded-2xl" />
        </Link>
        <div className="w-full max-w-sm">
          <NewPasswordForm token={token} />
        </div>
      </div>
    </div>
  );
}
